// src/pages/PainelAgendamentos/Tabela/TabelaAgendamentoModals.jsx
import { motion, AnimatePresence } from "framer-motion";
import FormEditarAgendamento from "../Editar/FormEditarAgendamento";
import DetalheAgendamento from "../Detalhe/DetalheAgendamento";
import ConfirmarExclusaoModal from "../Detalhe/ConfirmarExclusaoModal";

export default function TabelaAgendamentoModals({
  modoEdicao,
  modoDetalhe,
  modoExcluir,
  agendamentoSelecionado,
  onFechar,
  onAtualizar,
  onConfirmarExclusao,
}) {
  return (
    <>
      {/* Modal Editar */}
      <AnimatePresence>
        {modoEdicao && agendamentoSelecionado && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="w-3/4 h-5/6 bg-white rounded-lg shadow-lg overflow-hidden"
              initial={{ scale: 0.9, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 50 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <FormEditarAgendamento
                agendamento={agendamentoSelecionado}
                onClose={onFechar}
                // 🔥 garante atualização da tabela em tempo real
                onAtualizar={() => {
                  if (onAtualizar) onAtualizar();
                  onFechar();
                }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal Detalhe */}
      <AnimatePresence>
        {modoDetalhe && agendamentoSelecionado && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="w-2/3 h-4/5 bg-white rounded-lg shadow-lg overflow-y-auto"
              initial={{ scale: 0.9, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 50 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <DetalheAgendamento
                agendamento={agendamentoSelecionado}
                onClose={onFechar}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal Exclusão */}
      <AnimatePresence>
        {modoExcluir && agendamentoSelecionado && (
          <ConfirmarExclusaoModal
            aberto={modoExcluir}
            chamadoId={agendamentoSelecionado.id}
            onFechar={onFechar}
            onConfirmar={async () => {
              await onConfirmarExclusao();
              if (onAtualizar) onAtualizar(); // 🔥 atualiza tabela ao excluir
            }}
          />
        )}
      </AnimatePresence>
    </>
  );
}
